import * as React from "react";
import { Row, Col, Button, Form, Table, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DropdownList } from "react-widgets";
import { Customer, DeliveryPoint, AuthStore, VinQueryDetails } from "../../../../../stores";
import { wrapInput, wrapCheckbox } from "../../../../../common/FormChangeWrapper";
import { SOURCES_AS61, SOURCES_ABTEKA, SOURCES_AB61 } from "../../../../../constants";
import { formatDate } from "../../../../../common/Formatting";

interface IProps {
    source: string;
    customers: Customer[];
    managerComment: string;
    commentForClient: string;
    deliveryPoints: DeliveryPoint[];
    deliveryPointId: number;
    vinQuery?: VinQueryDetails;
    openCustomerSelector: () => void;
    openMobileViewModal: () => void;
    openCdekFormModal: () => void;
    onFormChange: (fieldName: string, value: any) => void;
    onFormCheckboxChange: (fieldName: string, value: string, checked: boolean) => void;
    selectedCustomer: string;
    selectedCustomerId?: string;
    hideCommercialFields: boolean;
    authStore: AuthStore;
    deliveryOverCdek: boolean;
    cdekToAddress: boolean;
    cdekAddress?: string;
}



export const FormComponent: React.StatelessComponent<IProps> = (props) => {
    return <Row>
        <Col sm={7}>
            <Row>
                <Col sm={7} >
                    {props.authStore.isCallCentre ?
                        <Form.Group as={Row} controlId="formSource">
                            <Form.Label column sm="4">
                                Источник
                            </Form.Label>
                            <Col sm="8">
                                <Form.Check inline id="sourceCheckboxAbteka" onChange={wrapCheckbox(props.onFormCheckboxChange)} name="source" label="Abteka" type="radio" value={SOURCES_ABTEKA} checked={props.source == SOURCES_ABTEKA} />
                                <Form.Check inline id="sourceCheckboxAb61" onChange={wrapCheckbox(props.onFormCheckboxChange)} name="source" label="ab61.ru" type="radio" value={SOURCES_AB61} checked={props.source == SOURCES_AB61} />
                                <Form.Check inline id="sourceCheckboxAs61" onChange={wrapCheckbox(props.onFormCheckboxChange)} name="source" label="as61.ru" type="radio" value={SOURCES_AS61} checked={props.source == SOURCES_AS61} />
                            </Col>
                        </Form.Group> : []
                    }
                    <Form.Group as={Row} controlId="formCustomer">
                        <Form.Label column sm="4">
                            Контрагент
                        </Form.Label>
                        <Col sm="8">
                            <div className="form-inline">
                                <div style={{ width: "100%", marginLeft: "-40px", paddingLeft: "40px" }}>
                                    {props.selectedCustomerId == undefined || props.selectedCustomerId.length == 0 ?
                                        <span style={{ color: "red" }}>Не выбран</span> :
                                        <span>{props.selectedCustomer}</span>}

                                </div>
                                <Button type="button" size="sm" style={{ marginLeft: "9px" }} onClick={props.openCustomerSelector}>
                                    <FontAwesomeIcon icon="caret-down" />
                                </Button>
                            </div>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="formHideCommercialFields">
                        <Form.Label column sm="4" title="Скрыть артикул и поставщика">
                            Скрыть комм. поля
                        </Form.Label>
                        <Col sm="4">
                            <Form.Check inline
                                title="Скрыть артикул и поставщика"
                                onChange={wrapCheckbox(props.onFormCheckboxChange)} name="hideCommercialFields" type="checkbox" checked={props.hideCommercialFields} />
                        </Col>
                        <Col sm="4" className="text-right">
                            <span onClick={props.openMobileViewModal} style={{ cursor: "pointer" }}>
                                <FontAwesomeIcon icon="mobile-alt" />  Моб.вид
                            </span>
                        </Col>
                    </Form.Group>
                </Col>
                <Col sm={5} >
                    <Form.Group as={Row} controlId="formCustomer">
                        <Form.Label column sm="4">
                            Точка выдачи
                        </Form.Label>
                        <Col sm="8">
                            {props.source == SOURCES_AS61 ? "Не используется" :
                                props.source == SOURCES_ABTEKA && props.authStore.isFranchise ? props.authStore.deliveryPointName :
                                    <DropdownList
                                        textField='fullName'
                                        valueField='id'
                                        filter='contains'
                                        data={[{ id: -1, fullName: "Не указано" }, ...props.deliveryPoints]}
                                        name="deliveryPointId"
                                        value={props.deliveryPointId}
                                        disabled={props.deliveryOverCdek}
                                        onChange={(value: DeliveryPoint) => props.onFormChange("deliveryPointId", value.id)}
                                        placeholder="Укажите точку выдачи"
                                    />
                            }
                        </Col>
                    </Form.Group>
                    {props.source == SOURCES_ABTEKA ? <Form.Group as={Row} controlId="formCustomer">
                        <Form.Label column sm="4">
                            Доставка СДЭК
                        </Form.Label>
                        <Col sm="8">
                            <Row>
                                <Col sm="4">
                                    <Form.Check inline
                                        title="Включить доставку СДЭКом"
                                        onChange={wrapCheckbox(props.onFormCheckboxChange)} name="deliveryOverCdek" type="checkbox" checked={props.deliveryOverCdek} />
                                </Col>
                                {props.deliveryOverCdek ?
                                    <Col sm="8" className="text-right">
                                        <Button size="sm" onClick={props.openCdekFormModal} variant="primary">
                                            <FontAwesomeIcon icon="mobile-alt" />  Настроить доставку
                                        </Button>
                                    </Col>
                                    : []}
                            </Row>
                        </Col>
                    </Form.Group> : []}
                    {props.source == SOURCES_ABTEKA && props.deliveryOverCdek && props.cdekAddress ? <div>
                        Отправка на {props.cdekToAddress ? "адрес клиента" : "терминал СДЭКа"}
                        <br />
                        Адрес: {props.cdekAddress}
                    </div>
                        : []}

                </Col>
            </Row>
            <Row>
                <Col sm="6">
                    <Form.Group controlId="formManagerComment">
                        <Form.Label>Комментарий менеджера</Form.Label>
                        <textarea
                            className="form-control"
                            name="managerComment"
                            value={props.managerComment}
                            onChange={wrapInput(props.onFormChange)}
                        ></textarea>
                    </Form.Group>
                </Col>
                <Col sm="6">
                    <Form.Group controlId="formCommentForClient">
                        <Form.Label>Комментарий клиенту</Form.Label>
                        <textarea
                            className="form-control"
                            name="commentForClient"
                            value={props.commentForClient}
                            onChange={wrapInput(props.onFormChange)}
                        ></textarea>
                    </Form.Group>
                </Col>
            </Row>
        </Col>
        <Col sm={5}>
            {props.vinQuery ? <Card>
                <Card.Header>VIN-запрос</Card.Header>
                <Card.Body>
                    <Form>

                        <Form.Group as={Row} controlId="formVin">
                            <Form.Label column sm="4">
                                Контрагент
                            </Form.Label>
                            <Col sm="8">
                                <Form.Control plaintext readOnly defaultValue={`${props.vinQuery.customerName} тел.(${props.vinQuery.customerPhone})`} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formVin">
                            <Form.Label column sm="4">
                                Дата запроса
                            </Form.Label>
                            <Col sm="8">
                                <Form.Control plaintext readOnly defaultValue={formatDate(props.vinQuery.dateAdded)} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formVin">
                            <Form.Label column sm="4">
                                Автомобиль
                            </Form.Label>
                            <Col sm="8">
                                <Form.Control plaintext readOnly defaultValue={props.vinQuery.carName} />
                            </Col>
                        </Form.Group>
                        {(props.vinQuery.engineCapacity != null || props.vinQuery.engineDisplacement != null || props.vinQuery.engineType != null) ?
                            <Form.Group as={Row} controlId="formVin">
                                <Form.Label column sm="4">
                                    Двигатель
                                </Form.Label>
                                <Col sm="8">
                                    <Form.Control plaintext readOnly defaultValue={(props.vinQuery.engineCapacity ?? "") + (props.vinQuery.engineDisplacement != null ? "(" + props.vinQuery.engineDisplacement + ") " : "") + (props.vinQuery.engineType ?? "")} />
                                </Col>
                            </Form.Group> : null}
                        <Form.Group as={Row} controlId="formVin">
                            <Form.Label column sm="4">
                                VIN/FRAME код
                            </Form.Label>
                            <Col sm="8">
                                <Form.Control plaintext readOnly defaultValue={props.vinQuery.vin} />
                            </Col>
                        </Form.Group>
                    </Form>
                </Card.Body>
            </Card> : []}
            <br />
        </Col>

    </Row>

}